'use client'

import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import { cn } from '@/lib/utils'

interface Props {
  className?: string
}

const LoadingPlaceholder = ({ className }: Props) => {
  return (
    <div className={cn('w-full h-full min-h-[150px] flex items-center justify-center', className)}>
      <div className='w-24 h-24'>
        <DotLottieReact
          src='/lottie/loading.lottie'
          loop
          autoplay
          style={{ width: '100%', height: '100%' }}
          renderConfig={{
            devicePixelRatio: 1,
            autoResize: true
          }}
        />
      </div>
    </div>
  )
}

export default LoadingPlaceholder
